export default __webpack_public_path__ + "static/banner-93cb1eaacbc182976664e202576ce946.svg";